'use strict';

function isDefined(o) {
  return o !== undefined;
}

module.exports = isDefined;